import { Module, MutationTree } from 'vuex';
import { RootState } from '../../types';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { AuthState } from './types';

const namespaced = true;

const state: AuthState = {
  authenticated: false,
  user: {
    accountId: -1,
    id: -1,
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    avatarColor: -1,
    team: [],
    groups: []
  },
  errorMessage: ''
};

const onboarding: Module<AuthState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations: mutations as MutationTree<AuthState>
};

export default onboarding;
